import JsBarcode from "jsbarcode";
import { io } from "socket.io-client";

export const PaymentOptions = [
    { payment_label: "Cash", payment_value: "cash" },
    { payment_label: "Credit", payment_value: "credit" },
];

export const generateBarcode = (text) => {
    let canvas = document.createElement("canvas");
    JsBarcode(canvas, text, {
        format: "CODE128",
        displayValue: true,
        jsbarcodeFontoptions: "bold",
        width: 2,
        height: 60
    });

    // Convert the canvas to an image
    let imageURL = canvas.toDataURL("image/png");

    // Open the barcode in a new tab
    let newTab = window.open();
    newTab.document.write('<img src="' + imageURL + '"/>');
    newTab.document.title = "Barcode";
};

export const socket = io("https://quickinventoryapi.royalbakery.co.in");

export const sendAmountToQr = (amount, store_id, device_id) => {
    socket.emit("send_to_qr", {
        store_id: store_id,
        user_id: device_id,
        amount: amount || 0,
    });
}
